<template>
    <b-overlay
        class="h-100"
        :show="status === 'loading' && !editMode"
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>
                    {{ $t('org.dashboard.Notice') }}
                </h4>
            </div>
            <router-link
                to="/notices"
            >
                <span
                    class="font-small-4 card-btn-more"
                >
                    {{ $t('org.dashboard.more') }}
                </span>
            </router-link>
            <hr class="card-board-divider w-80">
        </div>
        <b-table
            class="table-dashboard-board"
            :class="{ 'table-no-data': !latestBoardDocuments.length }"
            :items="latestBoardDocuments"
            :fields="fields"
            borderless
            hover
            thead-class="d-none"
            @row-clicked="goToBoardDetail"
            style="margin-top: 4px; margin-bottom: 7px;"
            show-empty
        >
            <template v-slot:empty>
                <div class="d-flex justify-content-center align-items-center flex-column text-center">
                    <SVGEmptyIcon/>
                    <span>{{ $t('org.dashboard.No data') }}</span>
                </div>
            </template>
        </b-table>
    </b-overlay>
</template>

<script>
import useDashboard from '@/composables/useDashboard'
import { getCurrentInstance, ref, computed } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        SVGEmptyIcon
    },
    props: ['editMode'],
    setup () {
        const vm = getCurrentInstance().proxy
        const { getBoardDocuments } = useDashboard()
        const [status, boardDocuments] = getBoardDocuments()
        const latestBoardDocuments = computed(() => boardDocuments.value.slice(0, 5))
        const goToBoardList = () => {
            vm.$router.push('/notices')
        }
        const goToBoardDetail = (document) => {
            vm.$router.push(`/notices/${document.service}/${document.timestamp}`)
        }
        /* table */
        const fields = ref([
            {
                label: '제목',
                key: 'subject',
                sortable: false,
                tdClass: ['p-1']
            },
            {
                label: '작성날짜',
                key: 'timestamp',
                sortable: false,
                tdClass: ['font-small-2', 'text-right', 'card-grey-B0'],
                formatter: (value, key, item) => {
                    const date = new Date(Number(value))
                    const YY = String(date.getFullYear()).substring(2, 4)
                    const MM = String(date.getMonth() + 1).length === 2 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`
                    const DD = String(date.getDate()).length === 2 ? date.getDate() : `0${date.getDate()}`
                    return `${YY}.${MM}.${DD}`
                }
            }
        ])
        return {
            status,
            fields,
            latestBoardDocuments,
            goToBoardList,
            goToBoardDetail
        }
    }
}
</script>

<style>
.card-grey-B0 {
    color: #B0B0B0;
}
.card-board-divider {
    width: 100%;
    color: #ebe9f1;
    margin: 0 1.7rem;
}
.table-dashboard-board td {
    padding-left: 1.7rem !important;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
}
.table-no-data {
    height: 80%;
}
</style>
